import * as React from 'react';
import {Swords} from 'lucide-react';
import {ChallengesIndexProps} from './ChallengesIndex.type';
import {CombatRow} from './_components/CombatRow';

function Breadcrumb({accountCode}: {accountCode: string}) {
  return (
    <nav className="challenges-breadcrumb" aria-label="Breadcrumb">
      <a href={`/${accountCode}/admin/`} className="challenges-breadcrumb__link">
        Dashboard
      </a>
      <span className="challenges-breadcrumb__separator">/</span>
      <span>Desafios</span>
    </nav>
  );
}

function EmptyState() {
  return (
    <div className="challenges-empty-state">
      <div className="challenges-empty-state__icon" aria-hidden="true">
        <Swords size={28} />
      </div>
      <p className="challenges-empty-state__title">Nenhum desafio encontrado</p>
      <p className="challenges-empty-state__hint">
        Os desafios criados na conta aparecerão aqui.
      </p>
    </div>
  );
}

export default function ChallengesIndex({account, challenges}: ChallengesIndexProps) {
  return (
    <section className="challenges-page">
      <Breadcrumb accountCode={account.code} />

      <header className="challenges-hero">
        <div className="challenges-hero__content">
          <div className="challenges-chip">
            <Swords size={16} />
            Desafios
          </div>
          <h1 className="challenges-title">Tabela de Combates</h1>
          <p className="challenges-hero__description">
            Acompanhe os desafios entre alunos da conta com a interface de combate.
          </p>
        </div>
      </header>

      <div className="challenges-card">
        <div className="challenges-card__header">
          <h2 className="challenges-card__title">
            <Swords size={20} />
            {challenges.length} {challenges.length === 1 ? 'desafio' : 'desafios'}
          </h2>
        </div>
        <div className="challenges-card__body challenges-card__body--flush">
          {challenges.length === 0 ? (
            <EmptyState />
          ) : (
            <ul className="challenges-list">
              {challenges.map((challenge) => (
                <li key={challenge.id} className="challenges-list__item">
                  <CombatRow challenge={challenge} />
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </section>
  );
}
